export default __webpack_public_path__ + "static/media/text-seal.be7cb52a.svg";